export default {"src":"/_next/static/media/brownies.88abf3ed.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};